import React from "react";

function ManualQA() {
  return <div>ManualQA</div>;
}

export default ManualQA;
